import { CoreManualClockModule } from '@vyce/core/src/modules';

import { useModuleData } from './hooks';

export const ManualClockModule = () => {
  const props = useModuleData();

  return <CoreManualClockModule {...props} />;
};
